import { Reducer, createSlice } from "@reduxjs/toolkit";
import { AppDispatch } from "../state";
import { SERVER_URL } from "../../utils/server";
import { Callback } from "../../index.d";
import { User } from "./authSlice";
import { toggleSessionExpired } from "../utils/uiSlice";
import { pageSizeReq } from "../../utils/constants";

export declare interface SinistreState {
  [index: string]: any;
}
const initialState: SinistreState = {};

export const sinistreSlice = createSlice({
  initialState,
  name: "sinistre",
  reducers: {
    createSinistre: (state, action) => {
      state[action.payload.id] = action.payload;
      return state;
    },
    listSinistre: (state, action) => {
      for (const obj of action.payload) {
        state[obj.id] = obj;
      }
      return state;
    },
    removeSinistre: (state, action) => {
      delete state[action.payload];
      return state;
    },
    updateSinistre: (state, action) => {
      state[action.payload.id] = {
        ...state[action.payload.id],
        ...action.payload,
      };
      return state;
    },
  },
});

export const {
  createSinistre,
  listSinistre,
  removeSinistre,
  updateSinistre,
} = sinistreSlice.actions;

export const listAsyncSinistre =
  () => async (dispatch: AppDispatch, getState: any) => {
    try {
      const user = getState().auth.user;

      const result = await fetch(
        `${SERVER_URL}sinistre/admin-all?size=${pageSizeReq}&page=1`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user?.token}`,
          },
        }
      );

      if (result.status === 403) {
        dispatch(toggleSessionExpired({ payload: true }));
        return;
      }
      const res = await result.json();

      if (res.data.length) {
        dispatch(listSinistre(res.data));
      }
    } catch (error) {
      console.log("list sinistre error", error);
      // onError?.();
    }
  };

export default sinistreSlice.reducer as Reducer<SinistreState>;
